import React, {useContext, useEffect, useState} from "react"
import {observer} from "mobx-react-lite"
import {socket} from "../const/socket"
import UserElement from "./user/UserElement";
import LoadingSpinner from "./Loading"
import SOCKET from "../const/socketNames"
import CustomModal from "./modal/CustomModal";
import {useStore} from "../store";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWindowClose, faUserPlus} from "@fortawesome/free-solid-svg-icons";
import {NotificationManager} from "react-notifications";
import FriendsModal from "./Friends/FriendsModal";
import { langFriends } from "./Friends/friendsTranslate";
import { displayName } from "../utils/displayName";
import emailClose from "../assets/images/email.png";
import emailOpen from "../assets/images/email_open.png";
import User from "../states/User";
import {popUp} from "../utils/helpers";
import { langContext } from "../App";
import { langSideNav } from "./sideNavTranslate";
import "../pages/homepage.css"

const SideNav = observer(({setSelected, searchInput, setSearchInput, groupChatOpened, setCloseMessagesModal, closeMessagesModal}) => {
    const lang = useContext(langContext);
    let showBySelected = langSideNav[lang]

    const [isOpen, setIsOpen] = useState(false)
    const [loading, setLoading] = useState(true)
    const [sort, setSort] = useState(false)
    const [selectedUser, setSelectedUser] = useState("")
    const [waitAnswerCall, setWaitAnswerCall] = useState(false)
    const [callStatus,setCallStatus] = useState(true)
    const [friendsOpen, setFriendsOpen] = useState(false)

    const {userStore, usersStore, videoRoomStore, chatStore, friendsStore} = useStore()

    useEffect(() => {
        friendsStore.loadRequests()

        socket.on(SOCKET.FRIEND_REQUEST, (data) => {
            friendsStore.loadRequests()
            const from = data?.from
            const name = displayName(from)
            NotificationManager.info(name || "", (langFriends[lang] || langFriends.eng).tr_newRequest, 5000, () => setFriendsOpen(true))
        })
        socket.on(SOCKET.FRIENDS_UPDATED, () => friendsStore.refreshAll())

        return () => {
            socket.off(SOCKET.FRIEND_REQUEST)
            socket.off(SOCKET.FRIENDS_UPDATED)
        }
    }, [])

    useEffect(() => {
        const timer = setInterval(() => {
            usersStore.getUsers();
        }, 300000)

        return () => clearInterval(timer)
    }, [])

    useEffect(() => setSelected(selectedUser), [selectedUser])


    function closeModal() {
        setCallStatus(true)
        setIsOpen(false);
        setWaitAnswerCall(false)
        setSelectedUser("")
        window.removeEventListener("beforeunload", cancelCall)
        const isCreateMessage = true
        socket.emit(SOCKET.SHUT_DOWN_CALL, selectedUser, User.username, isCreateMessage, videoRoomStore.roomId)
    }


   function cancelCall (event) {
             if(waitAnswerCall) {
                setIsOpen(false);
                socket.emit(SOCKET.SHUT_DOWN_CALL, selectedUser, User.username,false)
             }
    }

    useEffect(() => {
            window.addEventListener("beforeunload", cancelCall)  
        return () => window.removeEventListener("unload", cancelCall)
    }, [waitAnswerCall])


    useEffect(() => {
        socket.on(SOCKET.CHAT_UNVIEWED_ROOMS, (data) => {
            if (data.role === "Admin") {
                chatStore.setAdminChat(true)
            } else {
                usersStore.setUnviewedChats(data.username)
            }
        })
        socket.on(SOCKET.CHAT_REFRESH_ROOMS, (data) => {
            usersStore.removeUnviewedChats(userStore.username)
        })
        socket.on(SOCKET.USERS_ONLINE_LIST, (users) => usersStore.setOnlineUsersList(users))        

        return () => {
            socket.off(SOCKET.CHAT_UNVIEWED_ROOMS)
            socket.off(SOCKET.CHAT_REFRESH_ROOMS)
            socket.off(SOCKET.USERS_ONLINE_LIST)
            
        }
    }, [])

    useEffect(() => {
        let timer = null
        if (waitAnswerCall) {
            timer = setTimeout(() => {
                closeModal()
            }, 60000)
        }
        if(!waitAnswerCall){
            clearTimeout(timer)
        }
        return () => clearTimeout(timer)

    }, [waitAnswerCall])

    useEffect(() => {
        socket.on(SOCKET.PRIVATE_CALL_ANSWER_APPROVE, () => {
            const joinCall = document.getElementById("joinCall");
            joinCall.removeAttribute("disabled");
            setCallStatus(false)
            joinCall.addEventListener("click", joinCallHandle);
            const audio = document.getElementById("audioCall")
            audio.pause()
        })

        socket.on(SOCKET.PRIVATE_CALL_ANSWER_CANCEL, () => {
            setIsOpen(false);
            setCallStatus(true)
        })

        return () => {
            socket.off(SOCKET.PRIVATE_CALL_ANSWER_APPROVE)
            socket.off(SOCKET.PRIVATE_CALL_ANSWER_CANCEL)
        }
    })


    useEffect(() => {
        usersStore.getUnreadMessages()
        userStore.role && setLoading(false)
    }, [])

    const users = usersStore.usersList.map((user) =>
        (<UserElement
            key={user._id}
            user={user}
            status={usersStore.onlineUsers.includes(user.username) && userStore.username}
            setWaitAnswerCall={setWaitAnswerCall}
            setSelectedUser={setSelectedUser}
            setIsOpen={setIsOpen}
            closeMessagesModal={closeMessagesModal}      
            setCloseMessagesModal={setCloseMessagesModal}   
        />))

    const getUsersBySearch = (e) => {
        usersStore.getUsers(e.target.value)
    }


    const getUnreadMessage = () => {
        if (!sort) {
            usersStore.viewedNewMessages()
            setSort(!sort)
        } else {
            usersStore.getUsers('')
            setSort(!sort)
        }
    }

    const joinCallHandle = () => {
        setIsOpen(false)
        setWaitAnswerCall(false)
        setCallStatus(true)
        if (videoRoomStore.roomId) {
            popUp(`/video-room/${videoRoomStore.roomId}?status=caller`)
        }
    }

    return (
        <div className="user-sidebar">
        <div  style={{"display":"flex", "width":"100%", "alignItems":"center", "padding-right": "5px"}} >
            <div className="search-input-div" style={{"flex":"1", "minWidth":"0", "width":"auto"}}>
              <div className="search-logo-back ">
                <img src="/search.png" className="search-logo"/>
              </div>
              <input
                onChange={(e) => {getUsersBySearch(e); setSearchInput(e.target.value)}}
                className="search-input"
                type="search"
                value={searchInput}
                placeholder={showBySelected.tr_search}
              />          
            </div>
            <button type="button" onClick={() => setFriendsOpen(true)} title={(langFriends[lang] || langFriends.eng).tr_friends}
                    className="relative flex justify-center items-center flex-shrink-0 rounded-lg add-friend"
                    style={{"width":"40px", "height":"40px", "color":"#4F6CF7"}}>
                <FontAwesomeIcon icon={faUserPlus} />
                {friendsStore.incomingCount > 0 && (
                    <span className="absolute top-0 right-0 bg-red-500 text-white rounded-full text-xs leading-none flex justify-center items-center"
                          style={{"minWidth":"16px", "height":"16px", "padding":"0 4px"}}>{friendsStore.incomingCount}</span>
                )}
            </button>
            { usersStore.unviewedChats.length > 0 ? (!sort ? <img src="/msclwith.png" style={{"width":"40px", "height":"40px","cursor":"pointer"}} onClick={getUnreadMessage}/>
                          : <img src="/msopwith.png" style={{"width":"40px", "height":"40px","cursor":"pointer"}} onClick={getUnreadMessage}/>) :
                    (!sort ? <img src="/msclwitout.png" style={{"width":"40px", "height":"40px","cursor":"pointer"}} onClick={getUnreadMessage}/>
                          : <img src="/msopwithout.png" style={{"width":"40px", "height":"40px","cursor":"pointer"}} onClick={getUnreadMessage}/>)
            }
        </div>
        <ul className="users-list-scroll" >
          {loading ? (
            <div className="flex justify-center items-center mt-10">
              <LoadingSpinner />
            </div>
          ) : users.length ? (
            users
          ) : !searchInput && (
            <div className="flex flex-col items-center text-center text-gray-500 mt-10 px-4 gap-3">
              <p className="fontstyles">{(langFriends[lang] || langFriends.eng).tr_noFriends}</p>
              <button type="button" onClick={() => setFriendsOpen(true)}
                      className="px-4 py-2 rounded-lg bg-blue-500 text-white hover:bg-blue-600">
                <FontAwesomeIcon icon={faUserPlus} /> {(langFriends[lang] || langFriends.eng).tr_addFriend}
              </button>
            </div>
          )}
        </ul>
       <FriendsModal isOpen={friendsOpen} onClose={() => setFriendsOpen(false)} />
       <div className="admin-chat-div">
        <div className="admin-div" onClick={() => {socket.emit(SOCKET.CHAT_CREATE, {
                username: userStore.username,
                guestUsername: "Admin",
              });
              chatStore.setAdminChat(false);
              socket.emit(SOCKET.CHAT_VIEWED_ROOMS, {
                name: userStore.username,
                caller: "Admin",
              });
            }}>
          <img src="/Iconadmin.png" className="admin-icon"
            
            alt="support"/>
            <p className="fontstyles titeles" style={{"margin":"0 10px"}}>Support</p>
            {chatStore.adminChat && <span className="bg-red-400 h-3 w-3 rounded-full" />}
        </div>
        </div>
        {waitAnswerCall && (
          <CustomModal  isClose={closeModal} isOpen={isOpen}>
            <div className="ans-waiting-div">
              <p className="ans-waiting-status">{callStatus
                      ? showBySelected.tr_waitingForResponse
                      : showBySelected.tr_connect}</p>
              <div className="ans-waiting-btns"> 
                <button
                  type="button"
                  onClick={() => closeModal(true)}
                  className="answer-waiting-reject"
                >
                  <img src="/Iconrejectcall.png" />
                  {showBySelected.tr_reject}
                </button>
                <input
                  className="ans-waiting disabled:cursor-default"
                  style={callStatus ? {"display" : "none"} : {}}
                  id="joinCall"
                  type="button"
                  value={showBySelected.tr_connect}
                  disabled
                />
               
              </div>
              <audio
                controls
                autoPlay
                style={{ display: "none" }}
                id="audioCall"
              >
                <source src="/gudok.mp3" type="audio/mp3" />
              </audio>

              
            </div>
          </CustomModal>
        )}
      </div>
    )
})

export default SideNav